/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export function getKeyFromValue(struct, value) {
  let result = "";

  Object.keys(struct).map((key) => {
    if (struct[key].trim().toLowerCase() === value.trim().toLowerCase()) {
      result = key;
    }
  });

  return result;
}
